module.exports = __webpack_public_path__ + "static/upcycle-6a844cb44463fd95087f73aa66160762.png";